import {createAction} from "redux-act";

export interface ISbkEligibility {
	eligible: boolean;
	geoAllowed: boolean;
	ageAllowed: boolean;
	country: string | null;
}

export const fetchSbkEligibility = createAction();
export const fetchSbkEligibilitySuccess = createAction<ISbkEligibility>();
export const fetchSbkEligibilityFailed = createAction();
